import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask'
/* COMPONENTES DO SISTEMA */
import { TemplateComponent } from './core/components/layout/template.component';
import { AppComponent } from './app.component';
import { FooterComponent } from './core/components/footer/footer.component';
import { ComprovanteVotoComponent } from './pages/eleitor/comprovante-voto/comprovante-voto.component';
import { CanditadoListarComponent } from './pages/eleitor/canditado-listar/canditado-listar.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthInterceptorProvider } from './core/config/auth-interceptors';
import { SharedUtil } from './core/utils/SharedUtil';
import { LocalUser } from './core/config/localUser';
import { AuthGuardService } from './core/guard/auth-guard.service';
import { StorageService } from './services/storage.service';
import { TermoAceiteComponent } from './pages/termo-aceite/termo-aceite.component';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { ErrorInterceptorProvider } from './core/config/error-interceptor';
import { SpinnerComponent } from './core/components/spinner/spinner.component';
import { SessaoNaoAbertaComponent } from './pages/sessao-nao-aberta/sessao-nao-aberta.component';
/* ### PRIMENG ### */
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { PanelModule } from 'primeng/panel';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { MessageService } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import {DialogModule} from 'primeng/dialog';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NgxSpinnerModule } from "ngx-spinner";
import { TermoGuardService } from './core/guard/aceiteTermo-guard.service';
import { InitialComponent } from './pages/initial/initial.component';
import { FalhaConexaoServidorComponent } from './pages/falha-conexao-servidor/falha-conexao-servidor.component';
import { AuthGuardADMINService } from './core/guard/auth-guard-ADMIN.service';
import { Error403Component } from './pages/error/error403/error403.component';
import { Error404Component } from './pages/error/error404/error404.component';
import { AuthGuardSessao } from './core/guard/auth-guard-sessao.service';
import { RedirectNavegadorIeComponent } from './pages/redirect-navegador-ie/redirect-navegador-ie.component';
//import { NgxCaptchaModule } from 'ngx-captcha';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { AdminComponent } from './pages/admin/admin.component';
import { GestorComponent } from './pages/gestor/gestor.component';
import { ListaGestoresComponent } from './pages/admin/lista-gestores/lista-gestores.component';
import { TableResultadoEleicaoComponent } from './shared/table-resultado-eleicao/table-resultado-eleicao.component';
import { TableResultadoParcialEleicaoComponent } from './shared/table-resultado-parcial-eleicao/table-resultado-parcial-eleicao.component';
import { ResultadoParcialEleicaoComponent } from './pages/gestor/resultado-parcial-eleicao/resultado-parcial-eleicao.component';
import { TableRelatorioVotosComponent } from './shared/table-relatorio-votos/table-relatorio-votos.component';
import { RelatorioVotosComponent } from './pages/gestor/relatorio-votos/relatorio-votos.component';
import { HomeComponent } from './pages/home/home.component';
import { CadastroGestorComponent } from './pages/admin/cadastro-gestor/cadastro-gestor.component';
import { CadastroAssistenteComponent } from './pages/admin/cadastro-assistente/cadastro-assistente.component';
import { ResultadoEleicaoComponent } from './pages/gestor/resultado-eleicao/resultado-eleicao.component';
import { BsModalRef, BsModalService, ModalBackdropComponent, ModalModule } from 'ngx-bootstrap/modal';
import { ComponentLoaderFactory } from 'ngx-bootstrap/component-loader';
import { PositioningService } from 'ngx-bootstrap/positioning';
import { ModalComprovanteZeresimaComponent } from './pages/gestor/modals/comprovante-zeresima/modal-comprovante-zeresima.component';
import { CadastroEleicaoComponent } from './pages/gestor/cadastro-eleicao/cadastro-eleicao.component';
import { ParametrizacoesComponent } from './pages/gestor/parametrizacoes/parametrizacoes.component';
import { ParametrizacoesEmailComponent } from './pages/gestor/parametrizacoes-email/parametrizacoesEmail.component';
import { CargoComponent } from './pages/gestor/parametrizacoes/cargo/cargo.component';
import { CandidatoComponent } from './pages/gestor/parametrizacoes/candidato/candidato.component';
import { CargoNomePipe, PreCandidatoComponent } from './pages/gestor/parametrizacoes/precandidato/precandidato.component';
import { CandidaturaComponent } from './pages/gestor/parametrizacoes/candidatura/candidatura.component';
import { CandidaturaNavComponent } from './pages/gestor/parametrizacoes/candidaturanav/candidaturanav.component';
import { AprovadorComponent } from './pages/gestor/parametrizacoes/aprovador/aprovador.component';
import { AngularEditorComponent, AngularEditorToolbarComponent } from '@kolkov/angular-editor';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { CountdownComponent } from './pages/countdown/countdown.component';
import { NgxPaginationModule } from 'ngx-pagination';

import { EleitorComponent } from './pages/gestor/parametrizacoes/eleitor/eleitor.component';
import { BlacklistComponent } from './pages/gestor/parametrizacoes/blacklist/blacklist.component';
import { BlacklistPreCandidatoComponent } from './pages/gestor/parametrizacoes/blacklistprecandidato/blacklistprecandidato.component';
import { BlacklistPrecandidatosCsvComponent } from './pages/gestor/modals/blacklistprecandidatos-csv-import/blacklistprecandidatos-csv-import.component';
import { BlacklistCsvComponent } from './pages/gestor/modals/blacklist-csv-import/blacklist-csv-import.component';
import { CargoCsvComponent } from './pages/gestor/modals/cargo-csv-import/cargo-csv-import.component';
import { CandidatoCsvComponent } from './pages/gestor/modals/candidato-csv-import/candidato-csv-import.component';
import { PreCandidatoCsvComponent } from './pages/gestor/modals/precandidato-csv-import/precandidato-csv-import.component';
import { EleitorCsvComponent } from './pages/gestor/modals/eleitor-csv-import/eleitor-csv-import.component';
import { Utils } from './utils/utils';
import { IntegracaoComponent } from './pages/gestor/parametrizacoes/integracao/integracao.component';
import { EmailComponent } from './pages/gestor/parametrizacoes-email/email/email.component';
import { EnvioComponent } from './pages/gestor/parametrizacoes-email/envio/envio.component';
import { EmailCsvComponent } from './pages/gestor/modals/email-csv-import/email-csv-import.component';
import { ModalRelatoriosCandidaturasComponent } from './pages/gestor/modals/relatorios-candidaturas/modal-relatorios-candidaturas.component';
import { Cargo } from './models/cargo.model';
import {PaginationComponent} from './pages/gestor/parametrizacoes/eleitor/paginacao.component';
import {PaginationAprovadorComponent} from './pages/gestor/parametrizacoes/aprovador/paginacao.component';
import {PaginationPreCandidatoComponent} from './pages/gestor/parametrizacoes/precandidato/paginacao.component';
import {ListaEleicoes} from './pages/gestor/preview/lista-eleicoes/lista-eleicoes.component';
import { GerarNovaSenhaComponent } from './pages/login/gerar-nova-senha/gerar-nova-senha.component';
import { GerarNovaSenhaAprovadorComponent } from './pages/login/gerar-nova-senha-aprovador/gerar-nova-senha-aprovador.component';

import { PreVisualizarEleicaoComponent } from './pages/gestor/pre-visualizar-eleicao/pre-visualizar-eleicao.component';
import { HeaderComponent } from './core/components/layout/header/header.component';
import { RelatorioEmailComponent } from './pages/gestor/relatorio-email/relatorio-email.component';
import { TableRelatorioEmailComponent } from './shared/table-relatorio-email/table-relatorio-email.component';
import { RelatorioEmailDetalhadoComponent } from './pages/gestor/relatorio-email-detalhado/relatorio-email-detalhado.component';
import { TableRelatorioEmailDetalhadoComponent } from './shared/table-relatorio-email-detalhado/table-relatorio-email-detalhado.component';

import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
import { FormularioPreCandidatoComponent } from './pages/precandidato/formulario-precandidato.component';
import { RedirecionamentoIntegracao } from './pages/redirecionamento-integracao/redirecionamento-integracao.component';
import { ConfirmaComponent } from './pages/precandidato/confirma/confirma.component';
import { AcessoNegadoComponent } from './pages/acesso-negado/acesso-negado.component';
import { RouterModule } from '@angular/router';
import { ListaCargosAprovadorComponent } from './pages/aprovador/lista-cargos.component';
import { ListaCandidaturasComponent } from './pages/aprovador/Candidaturas/lista-candidaturas.component';
import { CandidaturasDeferidasComponent } from './pages/aprovador/Candidaturas/deferidas/candidaturas-deferidas.component';
import { CandidaturasAnalisadasComponent } from './pages/aprovador/Candidaturas/analisadas/candidaturas-analisadas.component';
import { CandidaturasIndeferidasComponent } from './pages/aprovador/Candidaturas/indeferidas/candidaturas-indeferidas.component';
import { CandidaturasPendentesComponent } from './pages/aprovador/Candidaturas/pendentes/candidaturas-pendentes.component';
import { PreCandidaturaRealizadaComponent } from './pages/precandidato/pre-candidatura-realizada/pre-candidatura-realizada.component';
import { ParametrizacoesAssistenteComponent } from './pages/assistente/parametrizacoes/parametrizacoes-assistente.component';
import { CandidatoAssistenteComponent } from './pages/assistente/parametrizacoes/candidato-assistente/candidato-assistente.component';
import { ResponsiveHtmlDirective } from './utils/responsivehtml'; 
import { ModalConfirmaCargoSemPlanoComponent } from './pages/gestor/modals/confirma-cargo-sem-plano/confirma-cargo-sem-plano.component';
import { ModalConfirmaEleitorSemPlanoComponent } from './pages/gestor/modals/confirma-eleitor-sem-plano/confirma-eleitor-sem-plano.component';



@NgModule({
  declarations: [
    AppComponent,
    TemplateComponent,
    FooterComponent,
    ComprovanteVotoComponent,
    CanditadoListarComponent,
    LoginComponent,
    CargoComponent,
    CandidatoComponent,
    CandidaturaComponent,
    CandidaturaNavComponent,
    PreCandidatoComponent,
    TermoAceiteComponent,
    WelcomeComponent,
    SpinnerComponent,
    SessaoNaoAbertaComponent,
    InitialComponent,
    FalhaConexaoServidorComponent,
    Error403Component,
    Error404Component,
    RedirectNavegadorIeComponent,
    AdminComponent,
    GestorComponent,
    ListaGestoresComponent,
    TableResultadoEleicaoComponent,
    TableResultadoParcialEleicaoComponent,
    HomeComponent,
    CadastroGestorComponent,
    CadastroAssistenteComponent,
    ResultadoEleicaoComponent,
    ResultadoParcialEleicaoComponent,
    ModalComprovanteZeresimaComponent,
    CadastroEleicaoComponent,
    CountdownComponent,
    ParametrizacoesComponent,
    EleitorComponent,
    AprovadorComponent,
    CargoCsvComponent,
    CandidatoCsvComponent,
    BlacklistComponent,
    BlacklistCsvComponent,
    PreCandidatoCsvComponent,
    EleitorCsvComponent,
    IntegracaoComponent,
    ParametrizacoesEmailComponent,
    EmailComponent,
    EnvioComponent,
    EmailCsvComponent,
    PaginationComponent,
    PaginationAprovadorComponent,
    PaginationPreCandidatoComponent,
    ListaEleicoes,
    GerarNovaSenhaComponent,
    GerarNovaSenhaAprovadorComponent,
    PreVisualizarEleicaoComponent,
    HeaderComponent,
    RelatorioVotosComponent,
    TableRelatorioVotosComponent,
    BlacklistPreCandidatoComponent,
    BlacklistPrecandidatosCsvComponent,
    FormularioPreCandidatoComponent,
    RedirecionamentoIntegracao,
    ConfirmaComponent,
    FormularioPreCandidatoComponent,
    RelatorioEmailComponent,
    TableRelatorioEmailComponent,
    RelatorioEmailDetalhadoComponent,
    TableRelatorioEmailDetalhadoComponent,
    AcessoNegadoComponent,
    ListaCandidaturasComponent,
    CandidaturasDeferidasComponent,
    CandidaturasIndeferidasComponent,
    CandidaturasPendentesComponent,
    CandidaturasAnalisadasComponent,
    ListaCargosAprovadorComponent,
    PreCandidaturaRealizadaComponent,
    CargoNomePipe,
    ModalRelatoriosCandidaturasComponent,
    ParametrizacoesAssistenteComponent,
    CandidatoAssistenteComponent,
    ResponsiveHtmlDirective,
    ModalConfirmaCargoSemPlanoComponent,
    ModalConfirmaEleitorSemPlanoComponent
  ],
  imports: [
    AngularEditorModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    MessagesModule,
    MessageModule,
    ToastModule,
    ConfirmDialogModule,
    TableModule,
    DropdownModule,
    PanelModule,
    TooltipModule,
    CheckboxModule,
    ButtonModule,
    LoadingBarHttpClientModule,
    LoadingBarModule,
    NgxMaskModule.forRoot(),
    //NgxCaptchaModule
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    NgxPaginationModule,
    RecaptchaV3Module,
    ModalModule.forRoot(),
    DialogModule
  ],

  providers: [
    {provide: RECAPTCHA_V3_SITE_KEY, useValue: "6LcVLCEhAAAAAJQ_tKRilSRPNDUQWuvCGSLkbv0h"},
    AuthInterceptorProvider,
    ErrorInterceptorProvider,
    StorageService,
    LocalUser,
    AuthGuardService,
    AuthGuardADMINService,
    TermoGuardService,
    AuthGuardSessao,
    ToastModule,
    SharedUtil,
    MessageService,
    NgxSpinnerModule,
    BsModalService,
    ComponentLoaderFactory,
    BsModalRef,
    Utils,
    PositioningService,
    CadastroEleicaoComponent,
    CandidatoComponent,
    RouterModule,
    ResponsiveHtmlDirective
  ],
  entryComponents: [
    ModalComprovanteZeresimaComponent,
    AngularEditorComponent,
    AngularEditorToolbarComponent,
    ModalRelatoriosCandidaturasComponent,
    ModalConfirmaCargoSemPlanoComponent,
    ModalConfirmaEleitorSemPlanoComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
